import { createRouter, createWebHistory } from "vue-router";

import GenericView from "../views/GenericView.vue";

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			component: GenericView,
			name: "home",
			path: "/",
		},
	],
});

export default router;
